/**
 * Collapse blank line(s) between consecutive same-type list items so a stray
 * blank doesn't split one list into two and leak a `<p></p>` that compounds on
 * each save/reload. Different-type transitions (bullet↔numbered) are left intact.
 * Idempotent.
 */
export function collapseSameTypeListItemGaps(markdown: string): string {
  return markdown
    .replace(/^([ \t]*[-*][ \t]+[^\r\n]*)(?:\r?\n){2,}(?=[ \t]*[-*][ \t]+)/gm, '$1\n')
    .replace(/^([ \t]*\d+\.[ \t]+[^\r\n]*)(?:\r?\n){2,}(?=[ \t]*\d+\.[ \t]+)/gm, '$1\n');
}
